(function ($) {
    var intervalArr = {};
    var videoIframes = $('.sp02-video-youtube .video-youtube > iframe');
    var lazyYoutubeVideo = $('.yt-lazyload');
    if (videoIframes.length === 0 && lazyYoutubeVideo.length === 0) return;

    var iframeParams = [
        {
            param: "enablejsapi",
            value: 1
        },
        {
            param: "version",
            value: 3
        }
    ];
    $(document).ready(function () {
        addYouTubeScript();

        setTimeout(function () {
            appendIframeParams(iframeParams);
            youtubeLazyloadSubtreeModified();
            waitForYouTubeAPI(onYouTubeIframeAPIReady);
        }, 1500);
    });

    function youtubeLazyloadSubtreeModified() {
        var lazyElements = $('.yt-lazyload');
        var ytparams = ["loop", "playlist", "rel"];
        var config = { childList: true, subtree: true };

        lazyElements.each(function () {
            var lazyElement = $(this);
            function handleMutationList(mutationList) {
                handleMutations(mutationList, lazyElement, ytparams);
            }

            var observer = new MutationObserver(handleMutationList);
            observer.observe(this, config);
        });
    }

    function handleMutations(mutationList, lazyElement, ytparams) {
        mutationList.forEach(function (mutation) {
            if (mutation.type === "childList") {
                lazyElement.find('iframe').each(function () {
                    handleIframe($(this), lazyElement, ytparams);
                });
            }
        });
    }

    function handleIframe(iframe, lazyElement, ytparams) {
        var src = iframe.attr('src');
        iframeParams.forEach(function (param) { if (!src.includes(param.param)) { var queryParam = {}; queryParam[param.param] = param.value; src = $.fn.urlUtil.mergeQuery(src, queryParam); iframe.attr('src', src); } });

        handleLazyElementAttributes(lazyElement, iframe, src, ytparams);

        var player = new YT.Player(iframe[0], {
            events: {
                onStateChange: function (event) {
                    handlePlayerStateChange(event, player);
                }
            }
        });
    }

    function handleLazyElementAttributes(lazyElement, iframe, src, ytparams) {
        if (lazyElement.attr('data-loop') == "True") {
            src = updateIframeSrc(iframe, src, ytparams[0], 1);
            if (lazyElement.attr('data-checked') == "0") {
                src = updateIframeSrc(iframe, src, ytparams[1], lazyElement.attr('data-id'));
            }
        } else if (lazyElement.attr('data-rel') == "True") {
            src = updateIframeSrc(iframe, src, ytparams[2], 0);
        }
    }

    function updateIframeSrc(iframe, src, param, value) {
        var queryParam = {};
        queryParam[param] = value;
        src = $.fn.urlUtil.mergeQuery(src, queryParam);
        iframe.attr('src', src);
        return src;
    }

    function handlePlayerStateChange(event, player) {
        var videoData = player.playerInfo.videoData;
        var pId = videoData.video_id;
        if (pId && intervalArr[pId]) {
            window.clearInterval(intervalArr[pId]);
            delete intervalArr[pId];
        }
        if (event.data === YT.PlayerState.PLAYING)
            trackYTAnalyticsLazy($(player.getIframe()), player);
    }

    function trackYTAnalyticsLazy($video, player) {
        var totDuration = player.playerInfo.duration;
        var timeoutVal = Math.round((totDuration / 100) * 1000);

        var intervalId = window.setInterval(function () {
            var pct = Math.round((player.playerInfo.currentTime / totDuration) * 100);
            if ([1, 25, 50, 75, 90, 99].includes(pct)) {
                var complete = pct + " pct complete";
                if (pct === 1)
                    complete = "video start click";
                if (pct === 99)
                    complete = "100 pct complete";

                $video.trigger('playvideo', [{
                    "eventType": complete, "elementText": player.videoTitle
                }]);
            }
            if ([1, 50, 75, 95].includes(pct)) {
                $video.trigger('goaltrigger', [{ "goal": pct === 1 ? "play" : pct }]);
            }
        }, timeoutVal);

        var videoPlayerData = player.playerInfo.videoData;
        var playerIdValue = player ? videoPlayerData.video_id : false;
        if (playerIdValue) {
            intervalArr[playerIdValue] = intervalId;
        }
    }


    function appendIframeParams(params) {
        // https://developers.google.com/youtube/iframe_api_reference#Example_Video_Player_Constructors
        // Setting the iframe attribute is supposed to work, but doesn't.  So we have to modify the video URL instead.
        //videoIframes.attr('appendIframeParams', true);
        var iframe, src;
        videoIframes.each(function () {
            iframe = $(this);
            src = iframe.attr('src');
            for (var i = 0; i < params.length; i++) {
                if (src.indexOf(params[i].param) < 0) {
                    var queryParam = {};
                    queryParam[params[i].param] = params[i].value;
                    src = $.fn.urlUtil.mergeQuery(src, queryParam);
                    iframe.attr('src', src);
                }
            }
        });
    }

    function addYouTubeScript() {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function waitForYouTubeAPI(callback) {
        if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
            setTimeout(function () {
                waitForYouTubeAPI(callback);
            }, 500);
        } else {
            callback();
        }
    }

    function onYouTubeIframeAPIReady() {
        $('.video-youtube > iframe').each(function () {
            var $video = $(this).parent();

            var player = new YT.Player(this, {
                events: {
                    onStateChange: function (event) {
                        var temp = player.getVideoData();
                        var pId = temp.video_id;
                        if (pId && intervalArr[pId]) {
                            window.clearInterval(intervalArr[pId]);
                            delete intervalArr[pId];
                        }
                        trackPlayerStatus($video, player);
                        if (event.data === YT.PlayerState.PLAYING)
                            trackYTAnalytics($video, player);
                    }
                }
            });
        });
    }

    function trackYTAnalytics($video, player) {
        var totDuration = player.getDuration();
        var timeoutVal = Math.round((totDuration / 100) * 1000);
        trackPlayerStatus($video, player);
        var intervalId = window.setInterval(function () {
            var pct = Math.round((player.getCurrentTime() / totDuration) * 100);
            if ([1, 25, 50, 75, 90, 99].includes(pct)) {
                var complete = pct + " pct complete";
                if (pct === 1)
                    complete = "video start click";
                if (pct === 99)
                    complete = "100 pct complete";

                $video.trigger('playvideo', [{
                    "eventType": complete, "elementText": player.getVideoData().title
                }]);
            }
            if ([1, 50, 75, 95].includes(pct)) {
                $video.trigger('goaltrigger', [{ "goal": pct === 1 ? "play" : pct }]);
            }
        }, timeoutVal);

        var videoPlayerData = player.getVideoData();
        var playerIdValue = player ? videoPlayerData.video_id : false;
        if (playerIdValue) {
            intervalArr[playerIdValue] = intervalId;
        }
    }

    function trackPlayerStatus($video, player) {
        var carouselElm = $video.closest('.c03-carousel');
        var autoplayValue = false;
        if (carouselElm.length > 0)
            autoplayValue = carouselElm.data('options').autoplay;
        var playerState = player.getPlayerState();
        if (autoplayValue) {
            if (playerState === 2 || playerState === 0)
                carouselElm.slick('slickPlay');
            else
                carouselElm.slick('slickPause');
        }
    }
}(window.jQuery));

/*Analytics*/
analytics.eventConfig.push(
    {
        "target": ".component.sp02-video-youtube",
        "codeId": "sp02",
        "events": [
            {
                "eventTarget": ".video-youtube",
                "eventType": "playvideo",
                "tags": {
                    "event": "video",
                    "componentName": "video youtube",
                    "componentId": "sp02",
                    "eventType": "",
                    "elementType": "youtube video",
                    "elementText": "",
                    "parentOrdinal": ""
                }
            }
        ]
    },
    {
        "target": ".yt-lazyload",
        "codeId": "sp10",
        "events": [
            {
                "eventTarget": ".yt-lazyload-content iframe",
                "eventType": "playvideo",
                "tags": {
                    "event": "video",
                    "componentName": "lazy load video youtube",
                    "componentId": "sp10",
                    "eventType": "",
                    "elementType": "lazy load youtube video",
                    "elementText": "",
                    "parentOrdinal": ""
                }
            }
        ]
    },
)
